namespace Areas {
    "use strict";

    export function highLightTextBase(idname: string) {

        var editorInstance = $(idname).dxHtmlEditor("instance");

        var textFormat = editorInstance.getFormat(editorInstance.getSelection().index, editorInstance.getSelection().length)

        if (textFormat.background == "yellow") {
            editorInstance.formatText(editorInstance.getSelection().index, editorInstance.getSelection().length, "background", "white");
        }
        else {
            editorInstance.formatText(editorInstance.getSelection().index, editorInstance.getSelection().length, "background", "yellow");
        }
    }

}